import { useFormikContext } from "formik";
import React from "react";
import { formatDate } from "../../../../utils/DateUtil";
import { PicturePet } from "../../../../components/picture-pet";
import { getValuePlain, iconsFile } from "../../../../utils/FormUtil";
import { size_pet } from "../../../../constants/constants";
import Chip from "@material-ui/core/Chip";
import { CloudUpload } from "@material-ui/icons";

export const ReviewProfilePet = ({}) => {
  const { values } = useFormikContext();

  const getRace = () => {
    if (values.race) {
      if (values.race.race === "Otro") {
        return values.customRace || "-";
      }
      return values.race.race;
    }
    return "-";
  };

  return (
    <div
      // className="detail-wrapper"
      className="pet-review-container"
    >
      <div style={{ paddingBottom: "20px" }}>
        <h2>Foto Cachorro</h2>
        <PicturePet url={values.urlPuppy} />
      </div>
      <div style={{ paddingBottom: "20px" }}>
        <h2>Foto Adulto</h2>
        <PicturePet url={values.urlAdult} />
      </div>
      <div className="detail">
        <div className="header header--detail">
          <h2>Información Personal</h2>
        </div>
        <div className="data-wrapper">
          <span className="data">
            {" "}
            Nombre:<span className="bold">{values.first_name || "-"}</span>
          </span>

          <span className="data">
            {" "}
            Especie:<span className="bold">{values.specie.species || "-"}</span>
          </span>
          <span className="data">
            {" "}
            Raza:<span className="bold">{getRace()}</span>
          </span>
          <span className="data">
            {" "}
            Sexo:
            <span className="bold">
              {values.sex_str === "MALE" ? "Macho" : "Hembra" || "-"}
            </span>
          </span>
          <span className="data">
            {" "}
            Castrado:
            <span className="bold">
              {values.castrated_str === "true" ? "Si" : "No" || "-"}
            </span>
          </span>
          <span className="data">
            {" "}
            Tamaño:
            <span className="bold">
              {
                getValuePlain(
                  size_pet.find((s) => s.value == values?.size?.value)
                )?.name
              }
            </span>
          </span>

          <span className="data">
            {" "}
            Fecha de Nacimiento:
            <span className="bold">{formatDate(values.birth_date) || "-"}</span>
          </span>
          <span className="data">
            {" "}
            Edad:<span className="bold">{values.age || "-"}</span>
          </span>
          <span className="data">
            {" "}
            Color de Pelaje:
            <span className="bold">{values.furColor || "-"}</span>
          </span>
        </div>
      </div>

      <div className="detail">
        <div className="header header--detail">
          <h2>Antecedentes Médicos</h2>
        </div>
        <div className="data-wrapper">
          <span className="data">
            {" "}
            Enfermedades Preexistentes:
            <span className="bold">
              {values.pre_existing_disease
                .map((item) => item.name)
                .join(", ") || "-"}
            </span>
          </span>

          <span className="data">
            {" "}
            Medicación frecuente:
            <span className="bold">
              {values.frequent_medication_check_box === "true"
                ? values.frequent_medication.map((item) => item.name).join(", ")
                : ""}
            </span>
          </span>
          <span className="data">
            {" "}
            Alergías:
            <span className="bold">
              {values.allergies_check_box === "true" ? values.allergies : ""}
            </span>
          </span>

          <span className="data">
            {" "}
            Cirugias:
            <span className="bold">
              {values.surgeries.map((item) => item.name).join(", ") || "-"}
            </span>
          </span>
          <div style={{ paddingTop: "10px" }}>
            <span className="data"> Libreta Sanitaria:</span>
            {values?.healthBooklet?.length !== 0 &&
              values.healthBooklet?.map((file, index) => (
                <div key={index} style={{ padding: "2px" }}>
                  <Chip
                    key={index}
                    avatar={iconsFile(file.type)}
                    label={file.name}
                    // onDelete={() => }
                    deleteIcon={<CloudUpload />}
                  />
                </div>
              ))}
          </div>
          <div style={{ paddingTop: "10px" }}>
            <span className="data">Estudios Médicos:</span>
            {values?.medicalStudies?.length !== 0 &&
              values.medicalStudies?.map((file, index) => (
                <div key={index} style={{ padding: "2px" }}>
                  <Chip
                    key={index}
                    avatar={iconsFile(file.type)}
                    label={file.name}
                    // onDelete={() => }
                    deleteIcon={<CloudUpload />}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
